
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';

import { getImage, getData } from '../../helpers/indexedDbHelper';
import {useTranslation} from 'react-i18next';
import { useRefresh } from '../../hooks/useRefresh';
import Alcoholic from './alcoholic';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import HappyHourScreen from './happyHour';
import CategoriesScreen from './categories';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';

function Index({dishMenu, setShowDetailProduct, setShowListProduct2}) { 

      const {i18n} = useTranslation();
      const langEng = i18n.language === 'en' ?? false;
  
      const { dish, alldish } = dishMenu;
  
      const [dataDish, setDataDish] = useState(dish);
      const [dataDesserts, setDataDesserts] = useState(false);
    const [dataDrinks, setDataDrinks] = useState(false);
     const [showHappy, setShowHappy] = useState(false);
     const [showCocktails, setShowCocktails] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(true); 
    const [showCategories, setshowCategories] = useState(false);
    const [menusData, setMenusData] = useState([]);
    
    const [image, setImage] = useState(false);
        const [showListProduct, setShowListProduct] = useState(false);
        const [dishs, setdishs] = useState(false);
  
      const {change} = useRefresh();
        const [menus, setMenus] = useState([]);
    
    const [flavors, setFlavors] = useState(dish.flavors);
    
    const [showSpecials, setShowSpecials] = useState(false);
     const [Beverages, setBeverages] = useState(false);
    
    
      useEffect(() => {
          getData('menu').then((items) => {
              const data = items.value.data;
              setMenus(data);
                setMenusData(data);
          });
      }, [change]);
      
      
    useEffect(() => {
        setIsImageLoading(true);
          fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
              if (url) {
                  setImage(url);
                  setIsImageLoading(false); 
              }
          });
      }, [dataDish]);
      
    
        useEffect(() => {
        setFlavors(dataDish.flavors)
        }, [dataDish])
    
   

    
    const isValidImage =(url) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true); // La imagen se cargó correctamente
                img.onerror = () => resolve(false); // La imagen está rota o no se puede cargar
                img.src = url; // Inicia la carga de la imagen
            });
        }
  
       useEffect(() => {
          menus.map((item) => {
              if (item.id === 874) {
              setDataDesserts(item);
              }
              
              if (item.id === 883) {
                  setDataDrinks(item)
              }

               if (item.id === 883) {
                setBeverages(item);
            }
         
          });
       }, [menus]);
    
     
    const GoBeverages2 = () => {
      
        setShowListProduct(true)
        setdishs(dataDesserts)
    }

    console.log({dishs});
  
  
      const fetchImage = async (id) => {
          const imageBlob = await getImage(id);
          if (imageBlob) {
              const imageURL = URL.createObjectURL(imageBlob.data.blob);
              return imageURL;
          }
          return null;
      };
  
  
      const navDish = (position) => {
          const menuIndex = alldish.findIndex(item => item === dataDish);
  
          let newIndex;
          if (position === 1) {
          newIndex = (menuIndex + 1) % alldish.length;
          } else if (position === -1) {
          newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
          } else {
          return;
          }
          const newDish = alldish[newIndex];
          setDataDish(newDish);
      };
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1000}}>
            <LayoutContent showCocktails={() => {
                GoBeverages2()
            }}  goCategories={() => {
               setShowListProduct(true)
               setdishs(dataDrinks)
            }}  showLogo={true}  showImageTop={false}  setShowListProduct={setShowDetailProduct} setShowSpecials={setShowSpecials} goHome={setShowListProduct2}>
                

                <div style={{
                    //backgroundImage: `url(${require('./assets/barra.png')})`,
                    background: "#c40722",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '94%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '12px 14px',
                    gap: 12,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 30
                }}>
                    {menusData.map((item, key) => {
                             if (![767, 444, 445, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: '#f9e6c8',
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '12px 28px',
                                    borderRadius: 25,
                                    minWidth: 'fit-content'
                            }}
                                    onClick={() => { 
                                        setShowListProduct(true)
                                        setdishs(item)
                                }}
                                >
                                    <p className='shor-text' style={{ color: '#000', fontFamily: 'Noodle', fontSize: 27, margin: 0, textTransform: 'uppercase',  }}>
{item.name}
                                        {/*
                                    {langEng ?
                                    `${item.name}`
                                :
                                `${translateMenu(
                                    i18n.language,
                                    item.language,
                                    item.name,
                                    'name'
                                )}`
                                        } */}
                                    </p>

                            </div>
                            }
                            
                        })}
                </div>


                <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '39%',
                        left: 20,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                          
                            borderRadius: 100,
                            borderWidth: 3,
                            borderColor: 'white',
                        }
                        }
                        onClick={() => [
                        navDish(-1),
                      
                        ]}>
                        <img
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: 45, height: 45, objectFit: 'contain',  pointerEvents: 'none', marginTop: 5}}
                            src={require('./assets/right.png')}
                        />
                    </div>
                </div>

                 <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '39%',
                        right: 20,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                           
                            borderRadius: 100,
                            borderWidth: 3,
                           
                        }
                        }
                        onClick={() => [
                        navDish(1),
                      
                        ]}>
                        <img
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: 45, height: 45, objectFit: 'contain',  pointerEvents: 'none', marginTop: 5}}
                            src={require('./assets/left.png')}
                        />
                    </div>
                </div>
                


                <div style={{marginTop: 20,overflow:'scroll',  opacity: isImageLoading ? 0 : 1, 
                                    transition: "opacity 0.5s ease-in-out",paddingInline: 20}}>
                    <div style={{ padding: '0px  0px 1px',  background: '#871014',  borderRadius: 14, }}>
                        <div
                            style={{
                                position: 'relative',
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                overflow: 'hidden',
                              
                            }}
                        >
                            <img
                                src={image}
                                alt="Dynamic content"
                                style={{
                                    width: "100%",
                                    height: 360,
                                    objectFit: "cover",
                                    borderRadius: 14,
                                    opacity: isImageLoading ? 0 : 1,
                                    transition: "opacity 0.5s ease-in-out",
                                }}
                                onLoad={() => setIsImageLoading(false)}
                            />
                           
                       </div>

                        <div style={{
                            
                            padding: 15,
                            borderRadius: 20,
                            
                        }}>
                                <div style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    display: 'flex',
                                    
                                    
                                }}>

                                    <div style={{
                                        fontFamily: "LondrinaSolidRegular",
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '80%'
                                    }}>
                                        <p className='shor-text-one' style={{fontSize: 32, color: '#f9e6c8', textAlign: 'left',  fontFamily: 'Noodle',}}>
                                        {langEng ? dataDish.name : translate(i18n.language, dataDish.language, dataDish.name)}
                                        </p>
                                    </div>

                                <div>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0px 10px',
                                        gap: 10,
                                        width: 130,
                                        textAlign: 'center',
                                        borderRadius: 20,
                                        padding: 5,
                                      
                                        boxSizing: 'border-box',
                                        background: '#f9e6c8',
                                       
                                    }}>
                                        <p
                                            style={{
                                                fontSize: 35,
                                                lineHeight: 1,
                                                color: '#871014',
                                               
                                                textAlign: 'center',
                                                fontFamily: "Noodle",
                                                margin: 0,
                                                letterSpacing: 1
                                            }}>
                                            {flavors.length === 0 && (
                                                <>
                                                    {dataDish.price > 0
                                                        ? `$ ${dataDish.label_price ?? ''} ${
                                                            dataDish.price.toFixed(2)
                                                        }`
                                                        : 'Market Price'}
                                                </>
                                            )}
                                    </p>
                                    

                                   
                                    </div>
                                </div>
                                    </div>
                                
                                <div>
                                    <p
                                        className='shor-text-one'
                                
                                    style={{fontSize: 22, textAlign:'left', color: '#f9e6c8', fontFamily: "Noodle",}}>
                                    {langEng ? 
                                                    `${dataDish.regular_decription.replace(/\\n/g,'\n')}`
                                                : 
                                                `${translateMenu(
                                                    i18n.language, 
                                                    dataDish.language, 
                                                    dataDish.regular_decription, 
                                                    'regular_decription'
                                                )}`
                                        }
                                        
                                        
                                    </p>
                            </div>
                            

                        {flavors.length > 0 && (
                        <div
                                    style={{
                                display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            flexWrap: 'wrap',
                            marginTop: 10,
                            }}>
                            {flavors.map((item, key) => {
                            return (
                                <div
                                key={key}
                                style={{
                                    backgroundColor: 'black',
                                    width: '29%',
                                    marginHorizontal: 1,
                                    margin: '1px 1px',
                                    borderRadius: 10,
                                    padding: 10,
                                    
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    position: 'relative',
                                    
                                }}>
                                    <p
                                        className='shor-text'
                                        style={{
                                            fontFamily: 'bignoodletitling',
                                            color: 'white',
                                            fontSize: 14,
                                            width: '85%',
                                        }}>
                                            {item.name}
                                    </p>

                                {item.price > 0 ? (
                                    <p
                                    className='shor-text'
                                    style={{
                                        color: 'white',
                                        position: 'absolute',
                                        right: 10,
                                        bottom: 6,
                                    }}>
                                    $ {item.price}
                                    </p>
                                ) : (
                                    <p
                                    style={{
                                        color: 'white',
                                        fontSize: 9,
                                        position: 'absolute',
                                        right: 10,
                                        bottom: 10,
                                    }}>
                                    Market Price
                                    </p>
                                )}
                                </div>
                            );
                            })}
                        </div>
                        )}
                                
                        </div>
                        
                    </div>

                    {dataDish.id == 3781 &&
                        <div>
                             <img
                                            src={require('./assets/sangria.png')}
                                            resizeMode={'cover'}
                                            style={{
                                                width: 480,
                                                height: 190,
                                                borderRadius: 14,
                                            
                                                objectFit: 'contain',
                                                boderRadius: 20,
                                            }}
                                        />
                        </div>
                    }

                    
                  
                    {dataDish.id != 3781 && 
                     <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: 10
                              
                                        
                                    
                                 
                                    }}>
                                    <div onClick={() => [setShowListProduct(true), setdishs(dataDesserts)]} style={{
                                                        borderRadius: 10,
                                                        display: 'flex',
                                                        justifyContent: "center",
                                                        elevation: 1,position: 'relative'}} >
                                <img
                                    onContextMenu={(e) => e.preventDefault()}
                                            src={require('./assets/desserts.png')}
                                            resizeMode={'cover'}
                                            style={{
                                                width: 320,
                                                height: 210,
                                                borderRadius: 14,
                                                 pointerEvents: 'none',
                                                objectFit: 'contain',
                                                boderRadius: 20,
                                            }}
                                        />
                                        
                                    </div>

                                   <div onClick={() => [setShowListProduct(true), setdishs(dataDrinks)]} style={{
                                                        borderRadius: 10,
                                                      
                                                        display: 'flex',
                                                        justifyContent: "center",
                                                        elevation: 1,position: 'relative'}}>
                                <img
                                    onContextMenu={(e) => e.preventDefault()}
                                            src={require('./assets/DSC08527.png')}
                                            resizeMode={'cover'}
                                        style={{
                                            width: 320,
                                                height: 210,
                                            borderRadius: 14,
                                             pointerEvents: 'none',
                                            objectFit: 'contain',
                                            boderRadius: 20,
                                        }}
                                    />
                                   
                                    </div>
                    </div>
                    }
                               
                   
                </div>
            </LayoutContent>
             {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
                goHome={setShowListProduct2}
            />}

            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowListProduct2} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
        </div>
    );
}
export default Index;